import { esc, escH, stars } from '../lib/helpers.js';

(function () {
  var data = window.__PAGE_DATA;
  if (!data || !data.authApiUrl) return;

  var AUTH = data.authApiUrl;
  var PLACE_ID = data.placeId;
  var BIZ_NAME = data.bizName;
  var BIZ_CITY = data.bizCity;
  var BIZ_STATE = data.bizState;
  var BIZ_SLUG = data.bizSlug;
  var BIZ_LOGO = data.bizLogo;
  var BIZ_ADDRESS = data.bizAddress;
  var BIZ_PHONE = data.bizPhone;
  var BIZ_WEBSITE = data.bizWebsite;
  var BIZ_DESCRIPTION = data.bizDescription;
  var authUser = null;
  var isOwner = false;
  var devToken = localStorage.getItem('ps_dev_token');
  var opts = { credentials: 'include' };

  // Dev auth: inject Bearer token for localhost
  var _origFetch = window.fetch;
  if (devToken) {
    window.fetch = function (url, o) {
      o = o || {};
      if (typeof url === 'string' && url.startsWith(AUTH)) {
        o.headers = o.headers || {};
        o.headers['Authorization'] = 'Bearer ' + devToken;
      }
      return _origFetch.call(window, url, o);
    };
  }

  // Check verified status + show claim button (runs for all visitors)
  fetch(AUTH + '/auth/claims/check?place_id=' + encodeURIComponent(PLACE_ID), opts)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (d.claimed) {
        var badge = document.getElementById('verified-badge');
        var badgeSm = document.getElementById('verified-badge-sm');
        if (badge) badge.style.display = 'inline-flex';
        if (badgeSm) badgeSm.style.display = 'inline-flex';
      }
      var btn = document.getElementById('claim-btn');
      var label = document.getElementById('claim-label');
      if (btn && label) {
        if (d.claimed && !d.is_owner) {
          // Already claimed by someone else
        } else if (d.is_owner) {
          label.textContent = 'Verified owner';
          btn.classList.add('text-green-600', 'border-green-300', 'bg-green-50');
          btn.style.display = '';
        } else if (d.user_claim && d.user_claim.status === 'pending') {
          var hasDomain = d.user_claim.verify_domain || d.domain;
          label.textContent = hasDomain ? 'Verify ownership' : 'Claim pending';
          btn.classList.add('text-amber-600', 'border-amber-300', 'bg-amber-50');
          btn.disabled = !hasDomain;
          btn.style.display = '';
        } else {
          btn.style.display = '';
        }
      }
    });

  // Check auth
  fetch(AUTH + '/auth/session/verify', opts)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      if (d.ok && d.user) {
        authUser = d.user;
        initFavorite();
        initClaim();
        initReviews();
        initOwnerPanel();
      } else {
        var lp = document.getElementById('review-login-prompt');
        var rf = document.getElementById('review-form');
        var wr = document.getElementById('write-review');
        if (lp && rf && wr) { lp.classList.remove('hidden'); rf.style.display = 'none'; wr.style.display = ''; }
        var btn = document.getElementById('claim-btn');
        if (btn) {
          btn.addEventListener('click', function () { window.location.href = '/account/'; });
        }
      }
      loadCommunityReviews();
      loadOwnerResponses();
    })
    .catch(function () {
      loadCommunityReviews();
      loadOwnerResponses();
    });

  // ── Favorites ──
  function initFavorite() {
    var btns = [document.getElementById('fav-btn'), document.getElementById('fav-btn-sm')].filter(Boolean);
    if (!btns.length) return;
    btns.forEach(function (b) { b.style.display = ''; });
    fetch(AUTH + '/auth/favorites?place_id=' + encodeURIComponent(PLACE_ID), opts)
      .then(function (r) { return r.json(); })
      .then(function (d) { setFavState(d.favorited); });

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isFav = btn.dataset.fav === '1';
        if (isFav) {
          fetch(AUTH + '/auth/favorites/' + encodeURIComponent(PLACE_ID), Object.assign({ method: 'DELETE' }, opts))
            .then(function () { setFavState(false); });
        } else {
          fetch(AUTH + '/auth/favorites', Object.assign({
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ place_id: PLACE_ID, business_name: BIZ_NAME, city: BIZ_CITY, state: BIZ_STATE, slug: BIZ_SLUG, logo_url: BIZ_LOGO, address: BIZ_ADDRESS, phone: BIZ_PHONE })
          }, opts)).then(function () { setFavState(true); });
        }
      });
    });
  }

  function setFavState(isFav) {
    var btns = [document.getElementById('fav-btn'), document.getElementById('fav-btn-sm')].filter(Boolean);
    btns.forEach(function (btn) {
      var icon = btn.querySelector('.fav-icon') || document.getElementById('fav-icon');
      btn.dataset.fav = isFav ? '1' : '0';
      if (isFav) {
        if (icon) icon.setAttribute('fill', 'currentColor');
        btn.classList.remove('text-red-300'); btn.classList.add('text-red-500');
        btn.classList.remove('border-slate-300'); btn.classList.add('border-red-300');
      } else {
        if (icon) icon.setAttribute('fill', 'none');
        btn.classList.add('text-red-300'); btn.classList.remove('text-red-500');
        btn.classList.add('border-slate-300'); btn.classList.remove('border-red-300');
      }
    });
  }

  // ── Claims ──
  function initClaim() {
    var btn = document.getElementById('claim-btn');
    var label = document.getElementById('claim-label');
    if (!btn || !label) return;
    var newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    var newLabel = document.getElementById('claim-label');

    fetch(AUTH + '/auth/claims/check?place_id=' + encodeURIComponent(PLACE_ID), opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.is_owner) {
          isOwner = true;
        } else if (d.user_claim && d.user_claim.status === 'pending') {
          var domain = d.user_claim.verify_domain || d.domain;
          if (domain) {
            newBtn.disabled = false;
            newBtn.addEventListener('click', function () {
              showVerifyModal(d.user_claim.id, domain);
            });
          }
        } else if (!d.claimed) {
          newBtn.addEventListener('click', function () {
            newBtn.disabled = true; newLabel.textContent = 'Claiming...';
            fetch(AUTH + '/auth/claims', Object.assign({
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ place_id: PLACE_ID, business_name: BIZ_NAME })
            }, opts))
              .then(function (r) { return r.json(); })
              .then(function (res) {
                if (res.ok) {
                  if (res.status === 'approved') {
                    newLabel.textContent = 'Verified owner';
                    newBtn.classList.add('text-green-600', 'border-green-300', 'bg-green-50');
                    isOwner = true;
                    initOwnerPanel('Your email domain matched your business website, so ownership was verified automatically.');
                    document.getElementById('owner-panel').scrollIntoView({ behavior: 'smooth', block: 'start' });
                  } else if (res.domain) {
                    newLabel.textContent = 'Verify ownership';
                    newBtn.classList.add('text-amber-600', 'border-amber-300', 'bg-amber-50');
                    newBtn.disabled = false;
                    newBtn.addEventListener('click', function () {
                      showVerifyModal(res.claim_id, res.domain);
                    });
                  } else {
                    newLabel.textContent = 'Claim pending';
                    newBtn.classList.add('text-amber-600', 'border-amber-300', 'bg-amber-50');
                  }
                } else {
                  newLabel.textContent = res.error || 'Claim failed';
                  newBtn.classList.add('text-red-600');
                }
              });
          });
        }
      });
  }

  function showVerifyModal(claimId, domain) {
    var modal = document.getElementById('claim-verify-modal');
    var desc = document.getElementById('claim-verify-desc');
    var emailInput = document.getElementById('claim-verify-email');
    var msg = document.getElementById('claim-verify-msg');
    var submitBtn = document.getElementById('claim-verify-btn');

    desc.textContent = 'Enter an email address at @' + domain + ' to verify you own this business. We\'ll send a verification link.';
    emailInput.value = '';
    emailInput.placeholder = 'you@' + domain;
    msg.classList.add('hidden');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Send verification email';
    modal.classList.remove('hidden');

    document.getElementById('claim-verify-cancel').onclick = function () {
      modal.classList.add('hidden');
    };
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.classList.add('hidden');
    });

    document.getElementById('claim-verify-form').onsubmit = function (e) {
      e.preventDefault();
      var email = emailInput.value.trim();
      if (!email) return;
      submitBtn.disabled = true; submitBtn.textContent = 'Sending...';
      msg.classList.add('hidden');

      fetch(AUTH + '/auth/claims/' + claimId + '/send-verification', Object.assign({
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }, opts))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          msg.classList.remove('hidden');
          if (d.ok) {
            msg.className = 'text-sm mb-3 text-green-700';
            msg.textContent = d.message || 'Verification email sent! Check your inbox.';
            submitBtn.textContent = 'Email sent';
          } else {
            msg.className = 'text-sm mb-3 text-red-600';
            msg.textContent = d.error || 'Failed to send verification email.';
            submitBtn.disabled = false; submitBtn.textContent = 'Send verification email';
          }
        })
        .catch(function () {
          msg.classList.remove('hidden');
          msg.className = 'text-sm mb-3 text-red-600';
          msg.textContent = 'Network error. Please try again.';
          submitBtn.disabled = false; submitBtn.textContent = 'Send verification email';
        });
    };
  }

  // ── Community Reviews ──
  function communityReviewCard(rev) {
    var photos = [];
    try { photos = typeof rev.photos === 'string' ? JSON.parse(rev.photos) : (rev.photos || []); } catch (e) { }

    var html = '<div class="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">';
    html += '<div class="flex items-center gap-3 p-4 pb-0">';
    if (rev.user_avatar) {
      html += '<img src="' + escH(rev.user_avatar) + '" class="w-10 h-10 rounded-full object-cover flex-shrink-0 bg-slate-100" onerror="this.outerHTML=\'<div class=\\\'w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-sm font-bold text-blue-600 flex-shrink-0\\\'>' + escH((rev.user_name || '?').charAt(0).toUpperCase()) + '</div>\'">';
    } else {
      html += '<div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-sm font-bold text-blue-600 flex-shrink-0">';
      html += escH((rev.user_name || '?').charAt(0).toUpperCase());
      html += '</div>';
    }
    html += '<div class="flex-1 min-w-0">';
    html += '<p class="font-semibold text-sm text-slate-900 truncate">' + escH(rev.user_name || 'Anonymous') + '</p>';
    html += '<div class="flex items-center gap-2">';
    html += '<span class="flex gap-0.5">';
    for (var i = 0; i < 5; i++) {
      html += '<svg class="w-4 h-4 ' + (i < rev.rating ? 'text-amber-400' : 'text-slate-200') + '" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
    }
    html += '</span>';
    var dateStr = rev.created_at ? new Date(rev.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
    html += '<span class="text-xs text-slate-400">' + escH(dateStr) + '</span>';
    html += '</div></div></div>';
    html += '<div class="px-4 py-3">';
    html += '<p class="text-sm text-slate-700 leading-relaxed">' + escH(rev.review_text) + '</p>';
    if (photos.length > 0) {
      html += '<div class="flex flex-wrap gap-2 mt-3">';
      photos.forEach(function (url) {
        html += '<a href="' + escH(url) + '" target="_blank" class="block w-20 h-20 rounded-lg overflow-hidden border border-slate-200">';
        html += '<img src="' + escH(url) + '" class="w-full h-full object-cover" loading="lazy">';
        html += '</a>';
      });
      html += '</div>';
    }
    html += '</div></div>';
    return html;
  }

  function loadCommunityReviews() {
    fetch(AUTH + '/auth/reviews?place_id=' + encodeURIComponent(PLACE_ID), opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok || !d.reviews || d.reviews.length === 0) return;
        var reviews = d.reviews;
        if (authUser && authUser.id) {
          reviews = reviews.filter(function (r) { return r.user_id !== authUser.id; });
        }
        if (reviews.length === 0) return;
        var section = document.getElementById('community-reviews');
        var list = document.getElementById('community-list');
        if (!section || !list) return;
        section.style.display = '';
        list.innerHTML = reviews.map(communityReviewCard).join('');
      });
  }

  // ── Owner Responses (overlay on Google reviews) ──
  function loadOwnerResponses() {
    fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID) + '/responses', opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok || !d.responses || d.responses.length === 0) return;
        window._ownerResponses = {};
        d.responses.forEach(function (resp) {
          window._ownerResponses[resp.review_id] = resp.response_text;
        });
        // Re-render review list so owner responses appear
        if (window._revRerender) window._revRerender();
      });
  }

  // ── Write Review ──
  var reviewPhotos = [];

  function initReviews() {
    var section = document.getElementById('write-review');
    var form = document.getElementById('review-form');
    if (!section || !form) return;
    section.style.display = '';

    fetch(AUTH + '/auth/reviews?place_id=' + encodeURIComponent(PLACE_ID) + '&mine=1', opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.reviewed && d.review) {
          form.style.display = 'none';
          document.getElementById('write-review-title').textContent = 'Write a Review';
          showMyReviewCard(d.review);
        }
      });

    var starSelect = document.getElementById('star-select');
    var ratingInput = document.getElementById('review-rating');
    if (starSelect) {
      starSelect.querySelectorAll('[data-star]').forEach(function (star) {
        star.addEventListener('click', function () {
          var val = parseInt(star.dataset.star);
          ratingInput.value = val;
          starSelect.querySelectorAll('[data-star]').forEach(function (s) {
            s.style.color = parseInt(s.dataset.star) <= val ? '#f59e0b' : '#cbd5e1';
          });
        });
      });
    }

    var textarea = document.getElementById('review-text');
    var charCount = document.getElementById('review-chars');
    if (textarea && charCount) {
      textarea.addEventListener('input', function () { charCount.textContent = textarea.value.length; });
    }

    var photoInput = document.getElementById('review-photo-input');
    if (photoInput) {
      photoInput.addEventListener('change', function () {
        var files = Array.from(photoInput.files || []);
        files.forEach(function (file) {
          if (reviewPhotos.length >= 5) return;
          if (file.size > 10 * 1024 * 1024) { showReviewMsg('Image too large (max 10MB).', 'red'); return; }
          reviewPhotos.push({ file: file, cdnUrl: null, uploading: false });
          renderReviewPhotos();
        });
        photoInput.value = '';
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var rating = parseInt(ratingInput.value);
      if (rating < 1 || rating > 5) { showReviewMsg('Please select a rating.', 'red'); return; }
      var text = textarea.value.trim();
      if (text.length < 10) { showReviewMsg('Review must be at least 10 characters.', 'red'); return; }

      var btn = document.getElementById('review-submit');
      btn.disabled = true; btn.textContent = 'Uploading photos...';

      uploadReviewPhotos(function (photoUrls) {
        var isEditing = !!window._editingReviewId;
        btn.textContent = isEditing ? 'Updating...' : 'Submitting...';
        var url = isEditing ? AUTH + '/auth/reviews/' + window._editingReviewId : AUTH + '/auth/reviews';
        var method = isEditing ? 'PATCH' : 'POST';
        fetch(url, Object.assign({
          method: method, headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ place_id: PLACE_ID, rating: rating, review_text: text, business_name: BIZ_NAME, photos: photoUrls })
        }, opts))
          .then(function (r) { return r.json(); })
          .then(function (d) {
            btn.disabled = false; btn.textContent = isEditing ? 'Update Review' : 'Submit Review';
            if (d.ok) {
              showReviewMsg(isEditing ? 'Review updated!' : 'Review submitted! Thank you.', 'green');
              form.style.display = 'none';
              showMyReviewCard({
                id: isEditing ? window._editingReviewId : d.review_id,
                rating: rating, review_text: text, photos: JSON.stringify(photoUrls),
                created_at: new Date().toISOString()
              });
              window._editingReviewId = null;
              reviewPhotos = [];
              loadCommunityReviews();
            } else {
              showReviewMsg(d.error || 'Failed to submit review.', 'red');
            }
          })
          .catch(function () {
            btn.disabled = false; btn.textContent = isEditing ? 'Update Review' : 'Submit Review';
            showReviewMsg('Network error. Please try again.', 'red');
          });
      });
    });
  }

  function renderReviewPhotos() {
    var container = document.getElementById('review-photos');
    if (!container) return;
    var html = '';
    reviewPhotos.forEach(function (p, idx) {
      if (!p.cdnUrl && !p._blobUrl) p._blobUrl = URL.createObjectURL(p.file);
      var src = p.cdnUrl || p._blobUrl;
      html += '<div class="relative w-20 h-20 rounded-lg overflow-hidden border border-slate-200 flex-shrink-0">';
      html += '<img src="' + src + '" class="w-full h-full object-cover">';
      html += '<button type="button" data-photo-idx="' + idx + '" class="review-photo-remove absolute top-0.5 right-0.5 w-5 h-5 bg-black/60 text-white rounded-full text-xs flex items-center justify-center hover:bg-black/80">&times;</button>';
      html += '</div>';
    });
    container.innerHTML = html;
    container.querySelectorAll('.review-photo-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-photo-idx'));
        var removed = reviewPhotos.splice(idx, 1)[0];
        if (removed && removed._blobUrl) URL.revokeObjectURL(removed._blobUrl);
        renderReviewPhotos();
      });
    });
    var msg = document.getElementById('review-photo-msg');
    if (msg) msg.textContent = reviewPhotos.length > 0 ? reviewPhotos.length + '/5 photos' : '';
  }

  function uploadReviewPhotos(callback) {
    var pending = reviewPhotos.filter(function (p) { return !p.cdnUrl; });
    if (pending.length === 0) {
      callback(reviewPhotos.map(function (p) { return p.cdnUrl; }).filter(Boolean));
      return;
    }

    var done = 0;
    pending.forEach(function (p) {
      fetch(AUTH + '/auth/reviews/upload', Object.assign({
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content_type: p.file.type, place_id: PLACE_ID })
      }, opts))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (!d.ok) { finish(); return; }
          return fetch(d.upload_url, {
            method: 'PUT',
            headers: { 'Content-Type': p.file.type },
            body: p.file
          }).then(function () {
            p.cdnUrl = d.cdn_url;
            finish();
          });
        })
        .catch(function () { finish(); });
    });

    function finish() {
      done++;
      if (done >= pending.length) {
        callback(reviewPhotos.map(function (p) { return p.cdnUrl; }).filter(Boolean));
      }
    }
  }

  function showReviewMsg(text, color) {
    var msg = document.getElementById('review-msg');
    if (!msg) return;
    msg.classList.remove('hidden');
    msg.className = 'text-sm ' + (color === 'green' ? 'text-green-700' : 'text-red-600');
    msg.textContent = text;
  }

  function showMyReviewCard(rev) {
    var slot = document.getElementById('my-review-slot');
    if (!slot) return;
    var section = document.getElementById('community-reviews');
    if (section) section.style.display = '';

    var photos = [];
    try { photos = typeof rev.photos === 'string' ? JSON.parse(rev.photos) : (rev.photos || []); } catch (e) { }

    var html = '<div class="bg-blue-50 border border-blue-200 rounded-xl shadow-sm overflow-hidden mb-3">';
    html += '<div class="flex items-center gap-3 p-4 pb-0">';
    if (authUser && (authUser.avatar_url || authUser.avatar)) {
      html += '<img src="' + escH(authUser.avatar_url || authUser.avatar) + '" class="w-10 h-10 rounded-full object-cover flex-shrink-0 bg-slate-100">';
    } else {
      html += '<div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center text-sm font-bold text-blue-600 flex-shrink-0">';
      html += escH(((authUser && authUser.name) || (authUser && authUser.email) || '?').charAt(0).toUpperCase());
      html += '</div>';
    }
    html += '<div class="flex-1 min-w-0">';
    html += '<div class="flex items-center gap-2">';
    html += '<p class="font-semibold text-sm text-slate-900 truncate">' + escH((authUser && authUser.name) || 'You') + '</p>';
    html += '<span class="text-xs font-medium text-blue-600 bg-blue-100 rounded-full px-2 py-0.5">Your review</span>';
    html += '</div>';
    html += '<div class="flex items-center gap-2">';
    html += '<span class="flex gap-0.5">';
    for (var i = 0; i < 5; i++) {
      html += '<svg class="w-4 h-4 ' + (i < rev.rating ? 'text-amber-400' : 'text-slate-200') + '" fill="currentColor" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';
    }
    html += '</span>';
    var dateStr = rev.created_at ? new Date(rev.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '';
    html += '<span class="text-xs text-slate-400">' + escH(dateStr) + '</span>';
    html += '</div></div></div>';
    html += '<div class="px-4 py-3">';
    html += '<p class="text-sm text-slate-700 leading-relaxed">' + escH(rev.review_text) + '</p>';
    if (photos.length > 0) {
      html += '<div class="flex flex-wrap gap-2 mt-3">';
      photos.forEach(function (url) {
        html += '<a href="' + escH(url) + '" target="_blank" class="block w-20 h-20 rounded-lg overflow-hidden border border-slate-200">';
        html += '<img src="' + escH(url) + '" class="w-full h-full object-cover" loading="lazy">';
        html += '</a>';
      });
      html += '</div>';
    }
    html += '<div class="flex items-center gap-4 mt-3 pt-3 border-t border-blue-100">';
    html += '<button type="button" id="edit-review-btn" class="text-xs font-medium text-blue-600 hover:text-blue-700 transition-colors">Edit</button>';
    html += '<button type="button" id="delete-review-btn" class="text-xs font-medium text-red-500 hover:text-red-600 transition-colors">Delete</button>';
    html += '</div>';
    html += '</div></div>';
    slot.innerHTML = html;

    document.getElementById('edit-review-btn').addEventListener('click', function () {
      slot.innerHTML = '';
      document.getElementById('write-review-title').textContent = 'Edit Review';
      var form = document.getElementById('review-form');
      form.style.display = '';
      document.getElementById('review-rating').value = rev.rating;
      document.getElementById('star-select').querySelectorAll('[data-star]').forEach(function (s) {
        s.style.color = parseInt(s.dataset.star) <= rev.rating ? '#f59e0b' : '#cbd5e1';
      });
      document.getElementById('review-text').value = rev.review_text;
      document.getElementById('review-chars').textContent = rev.review_text.length;
      reviewPhotos = photos.map(function (url) { return { cdnUrl: url, file: null }; });
      renderReviewPhotos();
      window._editingReviewId = rev.id;
      document.getElementById('review-submit').textContent = 'Update Review';
    });

    document.getElementById('delete-review-btn').addEventListener('click', function () {
      if (!confirm('Delete your review?')) return;
      fetch(AUTH + '/auth/reviews/' + rev.id, Object.assign({ method: 'DELETE' }, opts))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.ok) {
            slot.innerHTML = '';
            document.getElementById('write-review-title').textContent = 'Write a Review';
            document.getElementById('review-form').style.display = '';
            resetReviewForm();
            loadCommunityReviews();
          }
        });
    });
  }

  function resetReviewForm() {
    document.getElementById('review-rating').value = '0';
    document.getElementById('review-text').value = '';
    document.getElementById('review-chars').textContent = '0';
    document.getElementById('star-select').querySelectorAll('[data-star]').forEach(function (s) { s.style.color = '#cbd5e1'; });
    reviewPhotos = [];
    renderReviewPhotos();
    window._editingReviewId = null;
    document.getElementById('review-submit').textContent = 'Submit Review';
  }

  // ── Owner Dashboard ──
  function ownerStars(r) { r = Math.round(r || 0); return '\u2605'.repeat(r) + '\u2606'.repeat(Math.max(0, 5 - r)); }
  var ownerPanelLoaded = false;

  function initOwnerPanel(blurbOverride) {
    if (!isOwner || ownerPanelLoaded) return;
    ownerPanelLoaded = true;

    var panel = document.getElementById('owner-panel');
    if (!panel) return;
    panel.style.display = '';

    if (blurbOverride) {
      document.getElementById('owner-verified-blurb').textContent = blurbOverride;
    }

    document.getElementById('owner-tabs').addEventListener('click', function (e) {
      var tab = e.target.closest('.owner-tab');
      if (!tab) return;
      var name = tab.getAttribute('data-tab');
      document.querySelectorAll('.owner-tab').forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');
      document.querySelectorAll('.owner-tab-content').forEach(function (c) { c.style.display = 'none'; });
      document.getElementById('owner-tab-' + name).style.display = '';
    });

    fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID), opts)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok) return;
        populateEditForm(d.edits || {});
        renderOwnerPhotos(d.photos || []);
        renderOwnerResponses(d.responses || []);
      });

    document.getElementById('owner-edit-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var form = e.target;
      var data = {};
      ['name', 'phone', 'website', 'address', 'description'].forEach(function (f) {
        data[f] = form.elements[f].value.trim();
      });
      var msg = document.getElementById('owner-edit-msg');
      msg.className = 'text-sm'; msg.textContent = 'Saving...'; msg.classList.remove('hidden');

      fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID), Object.assign({
        method: 'PATCH', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }, opts))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.ok) {
            msg.className = 'text-sm text-green-700'; msg.textContent = 'Changes saved!';
          } else {
            msg.className = 'text-sm text-red-600'; msg.textContent = d.error || 'Save failed';
          }
          setTimeout(function () { msg.classList.add('hidden'); }, 3000);
        });
    });

    document.getElementById('owner-photo-input').addEventListener('change', function (e) {
      var file = e.target.files[0];
      if (!file) return;
      uploadOwnerPhoto(file);
      e.target.value = '';
    });
  }

  function populateEditForm(edits) {
    var form = document.getElementById('owner-edit-form');
    form.elements.name.value = edits.name || BIZ_NAME;
    form.elements.phone.value = edits.phone || BIZ_PHONE;
    form.elements.website.value = edits.website || BIZ_WEBSITE;
    form.elements.address.value = edits.address || BIZ_ADDRESS;
    form.elements.description.value = edits.description || BIZ_DESCRIPTION;
  }

  var ownerPhotos = [];

  function renderOwnerPhotos(photos) {
    ownerPhotos = photos;
    var grid = document.getElementById('owner-photos-grid');
    document.getElementById('owner-photo-count').textContent = photos.length;
    var upload = document.getElementById('owner-photo-upload');
    if (photos.length >= 20) { upload.style.display = 'none'; } else { upload.style.display = ''; }

    if (photos.length === 0) {
      grid.innerHTML = '<p class="text-sm text-slate-400 col-span-full">No photos uploaded yet.</p>';
      return;
    }
    grid.innerHTML = photos.map(function (p) {
      return '<div class="relative group">'
        + '<img src="' + escH(p.url) + '" alt="Owner photo" class="w-full h-24 sm:h-28 object-cover rounded-lg border border-slate-200">'
        + '<button type="button" onclick="deleteOwnerPhoto(\'' + esc(p.id) + '\')" class="absolute top-1 right-1 w-6 h-6 bg-red-600 text-white rounded-full text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center" title="Delete">&times;</button>'
        + '</div>';
    }).join('');
  }

  window.deleteOwnerPhoto = function (photoId) {
    if (!confirm('Delete this photo?')) return;
    fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID) + '/photos/' + photoId, Object.assign({ method: 'DELETE' }, opts))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.ok) {
          renderOwnerPhotos(ownerPhotos.filter(function (p) { return p.id !== photoId; }));
        }
      });
  };

  function uploadOwnerPhoto(file) {
    var msg = document.getElementById('owner-photo-msg');
    msg.className = 'text-sm ml-3 text-slate-500'; msg.textContent = 'Uploading...'; msg.classList.remove('hidden');

    var extMap = { 'image/jpeg': 'image/jpeg', 'image/png': 'image/png', 'image/webp': 'image/webp' };
    var ct = extMap[file.type];
    if (!ct) { msg.className = 'text-sm ml-3 text-red-600'; msg.textContent = 'Use JPEG, PNG, or WebP.'; return; }

    fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID) + '/photos', Object.assign({
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ content_type: ct })
    }, opts))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.ok) { msg.className = 'text-sm ml-3 text-red-600'; msg.textContent = d.error || 'Upload failed'; return; }
        return fetch(d.upload_url, { method: 'PUT', headers: { 'Content-Type': ct }, body: file })
          .then(function () {
            ownerPhotos.push({ id: d.photo_id, url: d.cdn_url, sort_order: ownerPhotos.length });
            renderOwnerPhotos(ownerPhotos);
            msg.className = 'text-sm ml-3 text-green-700'; msg.textContent = 'Uploaded!';
            setTimeout(function () { msg.classList.add('hidden'); }, 2000);
          });
      })
      .catch(function () {
        msg.className = 'text-sm ml-3 text-red-600'; msg.textContent = 'Network error.';
      });
  }

  function renderOwnerResponses(existingResponses) {
    var list = document.getElementById('owner-responses-list');
    var reviewData = window.__REVIEW_DATA;
    if (!reviewData || !reviewData.reviews || reviewData.reviews.length === 0) {
      list.innerHTML = '<p class="text-sm text-slate-400">No Google reviews to respond to.</p>';
      return;
    }

    var respMap = {};
    existingResponses.forEach(function (r) { respMap[r.review_id] = r.response_text; });

    var html = '';
    reviewData.reviews.forEach(function (rev) {
      var rid = rev.id || rev.review_id;
      if (!rid) return;
      var existing = respMap[rid] || '';
      var snippet = (rev.review_text || '').slice(0, 120);
      if ((rev.review_text || '').length > 120) snippet += '...';

      html += '<div class="bg-white border border-slate-200 rounded-lg p-3">';
      html += '<div class="flex items-center gap-2 mb-1">';
      html += '<span class="font-semibold text-xs text-slate-800">' + escH(rev.profile_name || 'Anonymous') + '</span>';
      html += '<span style="color:#f59e0b;font-size:11px">' + ownerStars(rev.rating) + '</span>';
      html += '</div>';
      html += '<p class="text-xs text-slate-500 mb-2">' + escH(snippet) + '</p>';

      if (existing) {
        html += '<div class="bg-green-50 border border-green-200 rounded p-2 mb-2">';
        html += '<p class="text-xs font-semibold text-green-700 mb-1">Your response</p>';
        html += '<p class="text-xs text-slate-600">' + escH(existing) + '</p>';
        html += '</div>';
      }

      html += '<div id="resp-form-' + esc(rid) + '">';
      html += '<textarea class="owner-field text-xs" rows="2" maxlength="2000" placeholder="' + (existing ? 'Edit your response...' : 'Write a response...') + '">' + escH(existing) + '</textarea>';
      html += '<div class="flex items-center gap-2 mt-1">';
      html += '<button type="button" onclick="submitOwnerResponse(\'' + esc(rid) + '\')" class="px-3 py-1 text-xs font-semibold text-white bg-green-600 hover:bg-green-700 rounded transition-colors">' + (existing ? 'Update' : 'Reply') + '</button>';
      html += '<span class="resp-msg text-xs hidden"></span>';
      html += '</div></div>';
      html += '</div>';
    });

    list.innerHTML = html;
  }

  window.submitOwnerResponse = function (reviewId) {
    var container = document.getElementById('resp-form-' + reviewId);
    if (!container) return;
    var textarea = container.querySelector('textarea');
    var msg = container.querySelector('.resp-msg');
    var text = textarea.value.trim();
    if (text.length < 5) { msg.className = 'resp-msg text-xs text-red-600'; msg.textContent = 'Response too short (min 5 chars).'; return; }

    var btn = container.querySelector('button');
    btn.disabled = true; btn.textContent = 'Saving...';
    msg.className = 'resp-msg text-xs'; msg.textContent = '';

    fetch(AUTH + '/auth/business/' + encodeURIComponent(PLACE_ID) + '/responses', Object.assign({
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ review_id: reviewId, response_text: text })
    }, opts))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.ok) {
          msg.className = 'resp-msg text-xs text-green-700'; msg.textContent = 'Saved!';
          btn.textContent = 'Update'; btn.disabled = false;
          window._ownerResponses = window._ownerResponses || {};
          window._ownerResponses[reviewId] = text;
        } else {
          msg.className = 'resp-msg text-xs text-red-600'; msg.textContent = d.error || 'Failed';
          btn.textContent = 'Retry'; btn.disabled = false;
        }
        setTimeout(function () { msg.classList.add('hidden'); }, 3000);
      });
  };

  // ── Removal Request ──
  var removalLink = document.getElementById('removal-link');
  if (removalLink) {
    removalLink.addEventListener('click', function (e) {
      e.preventDefault();
      document.getElementById('removal-modal').style.display = 'flex';
    });
  }

  var removalForm = document.getElementById('removal-form');
  if (removalForm) {
    removalForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('button[type="submit"]');
      var msg = document.getElementById('removal-msg');
      var email = document.getElementById('removal-email').value;
      btn.disabled = true; btn.textContent = 'Sending...';
      msg.className = 'text-sm mb-3 text-slate-500'; msg.textContent = 'Sending...'; msg.classList.remove('hidden');
      fetch('https://removal.prosource.app/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slug: BIZ_SLUG, email: email })
      }).then(function (r) { return r.json(); }).then(function (d) {
        btn.disabled = false; btn.textContent = 'Send Verification Email';
        if (d.ok) {
          msg.className = 'text-sm mb-3 text-green-700';
          msg.textContent = d.message || 'Verification email sent. Check your inbox.';
        } else {
          msg.className = 'text-sm mb-3 text-red-600';
          msg.textContent = d.error || 'Request failed.';
        }
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Send Verification Email';
        msg.className = 'text-sm mb-3 text-red-600';
        msg.textContent = 'Network error. Please try again.';
      });
    });
  }
})();
